import { NgStyle } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";

import { type AboutMenu, type Category } from "@hermes/api-model-menu";
import { MenuEntryType } from "@hermes/api-model-shell";

import {
    getEdito,
    AsMenuEntryItemWithEditoPipe,
} from "@hermes/domains-shell-fragments-menu-shared";

import {
    getCategoryMaxHeight,
    getCategoryMinHeight,
} from "../../../helpers/menu-category-height.helper";
import { MenuBarEditoComponent } from "../menu-bar-edito/menu-bar-edito.component";
import { MenuBarLinkComponent } from "../menu-bar-link/menu-bar-link.component";

@Component({
    selector: "h-menu-sub-category",
    imports: [
        MenuBarEditoComponent,
        NgStyle,
        MenuBarLinkComponent,
        AsMenuEntryItemWithEditoPipe,
    ],
    templateUrl: "./menu-sub-category.component.html",
    styleUrls: ["./menu-sub-category.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSubCategoryComponent implements OnInit {
    @Input()
    public menuEntry?: Category = undefined;

    @Input()
    public menuAboutEntry?: AboutMenu = undefined;

    @Output()
    public closeSubMenu: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input()
    public isFirstCategory: boolean = false;

    @Input()
    public isLastCategory: boolean = false;

    public menuEntryType = MenuEntryType;

    public categoryMaxHeight: string = "330px";
    public categoryMinHeight: string = "42px";

    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    public edito?: any;

    public ngOnInit(): void {
        this.edito = this.menuEntry ? getEdito(this.menuEntry) : undefined;
        this.categoryMaxHeight = this.menuEntry
            ? getCategoryMaxHeight(this.menuEntry)
            : "auto";
        this.categoryMinHeight = this.menuEntry
            ? getCategoryMinHeight(this.menuEntry)
            : "auto";
    }

    public onEscapeKey(event: Event): void {
        event.stopPropagation();
        this.closeSubMenu.emit();
    }

    public onKeyDown(
        event: KeyboardEvent,
        index: number,
        subIndex?: number,
    ): void {
        if (
            event.key === "Tab" &&
            this.menuEntry &&
            Array.isArray(this.menuEntry.subcategories)
        ) {
            const isLastCategory =
                index === this.menuEntry.subcategories.length - 1;
            const menuEntry = this.menuEntry.subcategories[index];

            const hasSubCategories =
                "subcategories" in menuEntry &&
                Array.isArray(menuEntry.subcategories) &&
                menuEntry.subcategories.length > 0;

            const isLastSubCategory =
                hasSubCategories &&
                subIndex !== undefined &&
                menuEntry.subcategories !== undefined &&
                subIndex === menuEntry.subcategories.length - 1;
            if (
                isLastCategory &&
                (!hasSubCategories || isLastSubCategory) &&
                this.isLastCategory
            ) {
                this.closeSubMenu.emit(true);
            }
        }
    }
}
